import React from 'react';
import Hero from './components/convocation/Hero';
import Main from './components/convocation/Main';

const Convocation = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default Convocation;